module.exports = __webpack_public_path__ + "img/awards_10.1dfda0be.png";